import React from 'react';
import {withRouter} from "./withRouter";
import {Col, Container, Row} from "react-bootstrap";

class CreateGame extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            companyId: null,
            genres: null,
            categories: null,
            isGenresLoaded: false,
            isCategoriesLoaded: false
        };

        const { navigate } = this.props;

        if(!this.props.companyId) {
            navigate('/login');
        }
    }

    componentDidMount() {
        if (this.props.companyId) {
            fetch(process.env.REACT_APP_API_URL + "/publisher/company/" + this.props.companyId + "/genres", {
                headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
            })
                .then(res => res.json())
                .then(
                    (result) => {
                        this.setState({
                            isGenresLoaded: true,
                            genres: result
                        });
                    },
                    (error) => {
                        this.setState({
                            isGenresLoaded: true,
                            error
                        });
                    }
                )

            fetch(process.env.REACT_APP_API_URL + "/publisher/company/" + this.props.companyId + "/categories", {
                headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
            })
                .then(res => res.json())
                .then(
                    (result) => {
                        this.setState({
                            isCategoriesLoaded: true,
                            categories: result.categories
                        });
                    },
                    (error) => {
                        this.setState({
                            isCategoriesLoaded: true,
                            error
                        });
                    }
                )
        }
    }

    handleSubmit(e) {
        e.preventDefault();

        const { navigate } = this.props;

        const body = {
            'name': e.target.name.value,
            'tags': e.target.tags.value.split(','),
            'genre': e.target.genre.value,
            'status': 'draft',
            'site': e.target.site.value,
            'game_category_id': this.state.categories > 0 ? e.target.game_category_id.value : null,
            'company_id': this.props.companyId,
        };

        console.log(body);

        fetch(process.env.REACT_APP_API_URL + '/publisher/game', {
            method: "POST",
            body: JSON.stringify(body),
            headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
        }).then(res => res.json())
            .then(
                (result) => {
                    this.setState({
                        isLoaded: true
                    });

                    console.log(body);

                    navigate('/account/company/' + this.props.companyId + '/game/' + result.id.toString());
                },
                (error) => {
                    this.setState({
                        isLoaded: true,
                        error
                    });
                }
            );
    }

    render() {
        const { error, isLoaded, genres, categories, isCategoriesLoaded, isGenresLoaded } = this.state;

        let content = null;

        if (error) {
            content = <div>{error ? <div className="alert alert-danger">
                <p>Session token has expired. Please, <a href="/account">login</a> again</p>
            </div> :<empty/>}</div>;
        } else if (! (isCategoriesLoaded && isGenresLoaded)) {
            content = <div>Loading...</div>;
        } else {
            content = (<div class="alert alert-light">
                <form onSubmit={this.handleSubmit.bind(this)}>
                    <label>Name: </label>
                    <input  class="form-control" required type="text" name="name"/>
                    <br/>
                    <label>Site: </label>
                    <input class="form-control" required type="url" name="site"/>
                    <br/>
                    <label>Tags: </label>
                    <input  class="form-control" required type="text" name="tags"/>
                    <small id="tags-help" className="form-text text-muted">Separate tags by comma</small>

                    <br/>
                    <br/>
                    <label>Genre: </label>
                    <select class="form-select" aria-label="Default select example" name="genre">
                        {genres.map(genre =>
                            <option key={genre} value={genre}>{genre.charAt(0).toUpperCase() + genre.slice(1)}</option>
                        )};
                    </select>
                    {/*<input class="form-control" required type="text" name="genre"/>*/}
                    <br/>
                    {/*categories.length > 0 ? <div>
                        <label>Game category: </label>
                        {/*<input class="form-control" required type="number" name="game_category_id"/>}
                        <select className="form-select" aria-label="Default select example" name="game_category_id">
                            {categories.map(category =>
                                <option key={category.id} value={category.id}>{category.name}</option>
                            )};
                        </select>
                    </div> : <div>
                        <input className="form-control" type="text" placeholder="Name: " name="new_category_name"/>
                        <br/>

                        <label>Description: </label>
                        <input className="form-control" type="text" placeholder="Description: " name="new_category_description"/>
                    </div>*/}
                    <br/>

                    <input class="btn btn-dark" required type="submit" value="Create app"/>
                </form>
            </div>);
        }

        return <Container>
            <Row>
                <Col>
                    {content}
                </Col>
            </Row>
        </Container>;
    }
}

export default withRouter(CreateGame);
